/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'

import PropTypes from 'prop-types'
import { Autocomplete } from '@material-ui/lab'
import { TextField, CircularProgress } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import helpers from 'helpers'

const UserTypeAndSearchInput = ({
  setUserId = () => {},
  kind = undefined,
  handleChangeUser = () => {},
  label = 'Usuário',
  fieldName = 'userId',
  multiple = false,
  searchField = 'name',
}) => {
  const [users, setUsers] = useState([])
  const [userInputValue, setUserInputValue] = useState('')
  const [isLoadingUsersInput, setIsLoadingUsersInput] = useState(false)

  const { control, errors } = useFormContext()

  const { loadUsers, instructionsText } = helpers.users.typeAndSearch
  const usersOptionsValues = isLoadingUsersInput ? [] : users

  const onChangeUser = (data) => {
    setUserId(data)
    handleChangeUser()
  }

  const handleTypeUsersInput = (e) => {
    setUserInputValue(e.target.value)
  }

  const mountUserParams = () => {
    return {
      [searchField]: userInputValue,
      minimal: true,
      perPage: 1000 * 1000,
      kind,
    }
  }

  useEffect(() => {
    const getUsers = setTimeout(() => {
      if (userInputValue.length < 3) return

      loadUsers(mountUserParams(), setIsLoadingUsersInput, setUsers)
    }, 1000)

    return () => clearTimeout(getUsers)
  }, [userInputValue])

  return (
    <Controller
      control={control}
      name={fieldName}
      onChange={([, data]) => {
        onChangeUser(data)
        return data
      }}
      mode="onBlur"
      as={
        <Autocomplete
          multiple={multiple}
          options={usersOptionsValues}
          getOptionLabel={(option) => option?.[searchField] || ''}
          getOptionSelected={(option, value) =>
            option?.id === value?.id || null
          }
          disableClearable
          noOptionsText={instructionsText(userInputValue)}
          loading={isLoadingUsersInput}
          renderInput={(params) => (
            <TextField
              {...params}
              error={!!errors?.[fieldName]}
              onChange={handleTypeUsersInput}
              helperText={errors?.[fieldName]?.message}
              label={label}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isLoadingUsersInput && (
                      <CircularProgress color="primary" size={20} />
                    )}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      }
    />
  )
}

UserTypeAndSearchInput.propTypes = {
  control: PropTypes.object,
  errors: PropTypes.object,
  setUserId: PropTypes.func,
  kind: PropTypes.string,
  handleChangeUser: PropTypes.func,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  multiple: PropTypes.bool,
}

export default UserTypeAndSearchInput
